import { useTranslation } from 'react-i18next';

import { Button } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';
import { useNavigation } from '@/hooks/navigation';
import { useGetCommonStore } from '@/store';
import { ScCompointsBanner } from './styled';

const BONUS_SHOP_PATH = '/bonus-shop';

export const CompointsBanner = () => {
  const { navigate } = useNavigation();
  const { t } = useTranslation('bonuses');

  const useCommonStore = useGetCommonStore();

  const compPoints = useCommonStore.use.compPoints();

  const userCompoints = compPoints?.chargeable?.points || 0;

  return (
    <ScCompointsBanner isWithButton>
      <ImageComponent
        alt="banner-char"
        className="banner-char"
        height={160}
        src="/bonuses/cp-banner-character.png"
        width={160}
      />

      <div className="header">
        <div className="title">
          <div>{t('exchangePoints.exchangeablePoints')}</div>
          <div className="balance">{userCompoints} CP</div>
        </div>
      </div>

      <Button
        onClick={() => navigate(BONUS_SHOP_PATH, true)}
        primary
        small
        wide
      >
        {t('exchangePoints.exchangeInShop')}
      </Button>
    </ScCompointsBanner>
  );
};
